<script>
import {BFormCheckbox} from 'bootstrap-vue'
import {ProductNames} from "@/libs/product";
export default {
    components: {BFormCheckbox},
    props: {
        selected: {
            required: true
        },
        options: {
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
        translations: {
            required: true
        }
    },
    data() {
        return {
            items: this.prepareOptions(this.options, this.selected)
        };
    },
    methods: {
        prepareOptions(options, selected) {
            return options.filter(option => option.key !== ProductNames.SCIP_NAME).map((option) => {
                let title = this.translations[option.key];
                let value = option.value;
                if (ProductNames.OTHER === option.key) {
                    title += ' (' + option.value.type + ')';
                    value = value.value;
                }
                return {
                    key: option.key,
                    title: title,
                    value: value,
                    selected: -1 !== selected.findIndex(type => type === option.key)
                };
            });
        },
        onChange() {
            this.$emit('input', this.items.filter(i => i.selected).map(i => i.key));
        }
    }
}
</script>

<template>
    <div class="other-names-selector">
        <div></div>
        <div v-for="option in items">
            <BFormCheckbox
                class="d-inline"
                :disabled="disabled"
                v-model="option.selected"
                @change="onChange"
            >
                {{ option.title }}: {{ option.value }}
            </BFormCheckbox>
        </div>
    </div>

</template>
